export default "__VITE_ASSET__7aTZiQ$V__"